import service from './service.js';

export default {
  searchDiMerito(data) {
    return service.execute('get', 'cercasentenze/dimerito?' + service.encodeQueryData(data));
  },
  searchAmministrative(data) {
    return service.execute('get', 'cercasentenze/amministrative?' + service.encodeQueryData(data));
  },
  getTribunali() {
    return service.execute('get', 'cercasentenze/tribunali');
  },
  getMaterie(filter) {
    return service.execute('get', 'cercasentenze/materie?' + service.encodeQueryData(filter));
  },
  getSediAmministrative() {
    return service.execute('get', 'cercasentenze/sediAmministrative');
  }
}



// WEBPACK FOOTER //
// ./src/services/search.js